import ApiInstance from "./ApiInstance";

class MeApi {
  async exportData(): Promise<any> {
    const { data } = await ApiInstance.getApi().get("/me/export");
    return data;
  }
  async deleteAccount(): Promise<void> {
    await ApiInstance.getApi().post("/me/delete", {});
  }
  async consents(): Promise<{ type: string; granted: boolean; version: string; at: string }[]> {
    const { data } = await ApiInstance.getApi().get("/me/consents");
    return data.consents;
  }
  async setConsent(type: string, action: "grant" | "withdraw"): Promise<void> {
    await ApiInstance.getApi().post(`/me/consents/${type}/${action}`, {});
  }
}

const meApi = new MeApi();
export default meApi;
